import Vue from "vue";
import VueRouter from "vue-router";
import routes from "@/router/routes";
import store from "@/store";
import { getters } from "@/store";
import { ROUTE_NAMES } from "@/router/constants";

Vue.use(VueRouter);

const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  const requiresAuth = to.matched.some(record => record.meta.requiresAuth);
  if (requiresAuth && !store.getters[getters.isAuthenticated]) {
    router.push({ name: ROUTE_NAMES.LOGIN });
  } else {
    next();
  }
});

export default router;
